import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M8.43 8.43 3 11l8 2 2 8 2.57-5.43", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17.39 11.73 22 2l-9.73 4.61", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "2", x2: "22", y1: "2", y2: "22", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "NavigationOff";
const NavigationOff = memo(themed(Icon));
export {
  NavigationOff
};
//# sourceMappingURL=navigation-off.js.map
